var translation = {
  SHOW_MORE: 'Ver más',
  SHOW_LESS: 'Ver menos'
};
export default translation;